import { ExtensionTrustSettingsService } from './service/extension-trust-settings.service';
import { Injectable } from '@angular/core';
import {
  CustomMessageListener,
  LuigiCoreService,
  LuigiNodesService,
} from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class TrustChangedListenerService implements CustomMessageListener {
  constructor(
    private luigiNodesService: LuigiNodesService,
    private luigiCoreService: LuigiCoreService,
    private trustService: ExtensionTrustSettingsService,
  ) {}

  public messageId(): string {
    return 'extension-trust.reload';
  }

  public onCustomMessageReceived(): void {
    this.reloadLuigi();
  }

  private reloadLuigi() {
    this.trustService.showTrustDialog.set(false);
    this.trustService.showRevokeTrustButton.set(true);
    this.luigiNodesService.clearNodeCache();
    this.luigiCoreService.clearNavigationCache();
    this.luigiCoreService.configChanged();
  }
}
